module.exports = __webpack_public_path__ + "static/media/grabber.d9b5e0b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/grabber.svg
// module id = 637
// module chunks = 1